import models from './models.js';
import pages from './pages/index.js';
import actions from './actions.js';
import messages from './messages.js';
import theme from './theme.js';

export default {
	common: { loading: 'Chargement…', step: 'Étape' },
	models,
	pages,
	actions,
	messages,
	theme,
	scrollActionController: {
		non_text_content: 'Contenu non textuel détecté'
	},
	charts: {
		riskScatter: {
			likelihood: 'Probabilité',
			impact: 'Impact'
		}
	}
};
